import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
import { classNames } from "../../../utils";
export const UnisatLogo = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = classNames(fillVariants({
      fill: "current"
    }), className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M13.292124,10.169532 C13.039548,10.178304 12.807048,10.289436 12.596544,10.501992 C12.38508,10.715496 12.27792,10.946568 12.274092,11.197128 C12.270276,11.446704 12.392748,11.698248 12.64248,11.94978 L14.235552,13.543836 C14.751264,14.064444 15.022992,14.56752 15.0498,15.05208 C15.076584,15.536616 14.81538,16.055292 14.268072,16.60812 C13.870992,17.0088 13.50072,17.25744 13.155324,17.35392 C12.809916,17.4504 12.48078,17.42904 12.167892,17.28768 C11.855016,17.14632 11.530656,16.90548 11.192904,16.56516 L8.227776,13.572096 C7.980924,13.322508 7.732152,13.200648 7.481472,13.204536 C7.23078,13.20942 6.9963672,13.320564 6.779172,13.539924 C6.5715456,13.749552 6.4653408,13.980612 6.46142632,14.234088 C6.457686,14.487576 6.5792004,14.738136 6.826056,14.987724 L9.72516,17.91456 L9.91893362,18.1032668 C10.3074519,18.467591 10.6904537,18.7419257 11.068536,18.92748 C11.509608,19.14396 11.955492,19.23564 12.40806,19.2024 C12.860628,19.16928 13.328484,19.00944 13.812636,18.72276 C14.296788,18.43608 14.804844,18.02472 15.336816,17.48748 C15.78366,17.03616 16.128108,16.5954 16.368252,16.164504 C16.609392,15.73356 16.75386,15.288984 16.80264,14.82978 C16.85718,14.29356 16.778736,13.812912 16.569204,13.387848 C16.35966,12.962748 16.019028,12.512328 15.54732,12.036564 L14.045148,10.534164 C13.796364,10.28262 13.544724,10.16076 13.292124,10.169532 Z M11.7835379,4.80952266 L11.589984,4.8160884 C11.138376,4.8492372 10.67052,5.0081532 10.187328,5.2947876 C9.703176,5.581428 9.195108,5.992848 8.663136,6.530052 C8.216304,6.981456 7.871856,7.42212 7.6317,7.853064 C7.390584,8.283984 7.246104,8.72856 7.1973072,9.187764 C7.1427696,9.723984 7.221228,10.204632 7.430772,10.629696 C7.640304,11.054796 7.980936,11.505216 8.452632,11.98098 L11.352708,14.90778 C11.60148,15.159336 11.85312,15.281196 12.10572,15.272412 C12.358308,15.26364 12.59082,15.152496 12.8013,14.939952 C13.012764,14.72646 13.119924,14.495376 13.123752,14.244816 C13.127568,13.995228 13.00512,13.743696 12.755388,13.492176 L9.765384,10.473732 C9.249648,9.954072 8.97792,9.450996 8.951136,8.96646 C8.92434,8.4819 9.185556,7.963224 9.73284,7.41042 C10.12992,7.0107 10.500192,6.762084 10.8456,6.665568 C11.190048,6.568068 11.519184,6.590496 11.832072,6.731868 C12.144936,6.873228 12.470256,7.114056 12.80706,7.454292 L15.773136,10.447404 C16.02,10.696008 16.268772,10.818852 16.519452,10.81494 C16.770144,10.81008 17.004564,10.698936 17.221752,10.479552 C17.429376,10.269948 17.535576,10.0389 17.5394912,9.785412 C17.54322,9.531924 17.421732,9.28038 17.174868,9.031776 L14.274792,6.104976 C13.818408,5.6448 13.370616,5.307462 12.929508,5.091024 C12.488436,4.874586 12.042552,4.7829408 11.589984,4.8160884 Z" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest || $[8] !== size || $[9] !== t2) {
    t4 = <svg aria-label="Unisat" className={t2} fill="currentColor" height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = rest;
    $[8] = size;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};